export const ExpertRecommendationLevelEnum = Object.freeze(
{
   Required:0,
   Optional:1,
   Recommended:2,
   StronglyRecommended:3
})

export const ExpertRecommendationLevelEnumLabels = Object.freeze(
{
   [ExpertRecommendationLevelEnum.Required]:"Required",
   [ExpertRecommendationLevelEnum.Optional]:"Optional",
   [ExpertRecommendationLevelEnum.Recommended]:"Recommended",
   [ExpertRecommendationLevelEnum.StronglyRecommended]:"Strongly Recommended",

})